import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import GeRealtimeBase from '../GeRealtimeBase';

var GeRealtime = /*#__PURE__*/function (_PureComponent) {
  _inherits(GeRealtime, _PureComponent);

  var _super = _createSuper(GeRealtime);

  function GeRealtime(props) {
    var _this;

    _classCallCheck(this, GeRealtime);

    _this = _super.call(this, props);
    _this.state = {
      countdown: null,
      disabled: false
    };
    _this.latest = props.value;
    return _this;
  }

  _createClass(GeRealtime, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      var countdown = this.state.countdown;

      if (countdown) {
        // 倒计时
        setTimeout(function () {
          if (!_this2.unmounted) {
            var now = new Date();

            if (now.getTime() > countdown) {
              // 倒计时结束
              _this2.setState({
                countdown: null,
                disabled: false
              });
            } else {
              // 倒计时未结束，重新渲染组件
              _this2.forceUpdate();
            }
          }
        }, 100);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unmounted = true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var latest = this.latest,
          props = this.props,
          _this$state = this.state,
          disabled = _this$state.disabled,
          countdown = _this$state.countdown;
      var render = props.render,
          getRefreshInterval = props.getRefreshInterval,
          getValue = props.getValue,
          onChange = props.onChange,
          refreshInterval = props.refreshInterval,
          value = props.value;
      return render({
        latest: latest,
        disabled: disabled,
        loadingCountdown: disabled && !countdown,
        getCountdown: function getCountdown() {
          return countdown ? "".concat(Math.ceil((countdown - new Date().getTime()) / 1000), "s") : '';
        },
        refresh: function () {
          var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            var _yield$Promise$all, _yield$Promise$all2, _yield$Promise$all2$, nextValue, _yield$Promise$all2$2, interval;

            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _this3.setState({
                      disabled: true
                    });

                    _context.next = 3;
                    return Promise.all([getValue(), getRefreshInterval()].map(function (promise) {
                      return Promise.resolve(promise).catch(function () {
                        return undefined;
                      });
                    }));

                  case 3:
                    _yield$Promise$all = _context.sent;
                    _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                    _yield$Promise$all2$ = _yield$Promise$all2[0];
                    nextValue = _yield$Promise$all2$ === void 0 ? value : _yield$Promise$all2$;
                    _yield$Promise$all2$2 = _yield$Promise$all2[1];
                    interval = _yield$Promise$all2$2 === void 0 ? refreshInterval : _yield$Promise$all2$2;
                    onChange(_this3.latest = nextValue);

                    _this3.setState({
                      countdown: new Date().getTime() + interval
                    });

                  case 11:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          function refresh() {
            return _refresh.apply(this, arguments);
          }

          return refresh;
        }()
      }, props);
    }
  }]);

  return GeRealtime;
}(PureComponent);

export { GeRealtime as default };
GeRealtime.propTypes = {
  getValue: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  refreshInterval: PropTypes.number,
  getRefreshInterval: PropTypes.func,
  render: PropTypes.func,
  value: PropTypes.any
};
GeRealtime.defaultProps = {
  refreshInterval: 10000,
  getRefreshInterval: function getRefreshInterval() {},
  render: GeRealtimeBase,
  value: null
};